import {CourseService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced: true,
    state: {
        courses:[],
        coursesOfTeacher: [],
    },

    mutations: {
        saveCourses(current, courses){
            current.courses = courses;
        },
        saveCoursesOfTeacher(current, courses){
            current.coursesOfTeacher = courses;
        }
    },

    actions: {
        async getCoursesOfAction({commit}, teacherId){
            await bindLoading(commit,
                async () => commit('saveCoursesOfTeacher', await CourseService.getCoursesOf(
                    {teacherId})), 'course');
        },
        async getCoursesWithKeyAction({commit}, key){
            await bindLoading(commit,
                async () => commit('saveCourses', await CourseService.getCoursesWithKey(
                    {key})), 'course');
        }
    }
}